import { render, staticRenderFns } from "./PointedList.vue?vue&type=template&id=462279d8&scoped=true&"
import script from "./PointedList.vue?vue&type=script&lang=js&"
export * from "./PointedList.vue?vue&type=script&lang=js&"
import style0 from "./PointedList.vue?vue&type=style&index=0&id=462279d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462279d8",
  null
  
)

component.options.__file = "PointedList.vue"
export default component.exports